import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ead6464e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("保密")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("男")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("女")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("提交")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("重置")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_UploadComponent = _resolveComponent("UploadComponent")!
  const _component_a_form_item_rest = _resolveComponent("a-form-item-rest")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createBlock(_component_a_form, {
    ref: "formRef",
    model: _ctx.formState,
    rules: _ctx.rules,
    "label-col": _ctx.labelCol,
    "wrapper-col": _ctx.wrapperCol
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_form_item, {
        ref: "name",
        label: "姓名",
        name: "name"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_input, {
            value: _ctx.formState.name,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formState.name) = $event))
          }, null, 8, ["value"])
        ]),
        _: 1
      }, 512),
      _createVNode(_component_a_form_item, {
        ref: "phone",
        label: "电话",
        name: "phone"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_input, {
            value: _ctx.formState.phone,
            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formState.phone) = $event))
          }, null, 8, ["value"])
        ]),
        _: 1
      }, 512),
      _createVNode(_component_a_form_item, {
        ref: "gender",
        label: "性别",
        name: "gender"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_radio_group, {
            value: _ctx.formState.gender,
            "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formState.gender) = $event))
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createBlock(_component_a_radio, {
                value: 0,
                key: 0
              }, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              })),
              (_openBlock(), _createBlock(_component_a_radio, {
                value: 1,
                key: 1
              }, {
                default: _withCtx(() => [
                  _hoisted_2
                ]),
                _: 1
              })),
              (_openBlock(), _createBlock(_component_a_radio, {
                value: 2,
                key: 2
              }, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              }))
            ]),
            _: 1
          }, 8, ["value"])
        ]),
        _: 1
      }, 512),
      _createVNode(_component_a_form_item, {
        ref: "head_img",
        label: "头像",
        name: "head_img"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_input, {
            value: _ctx.formState.head_img,
            "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formState.head_img) = $event)),
            style: {"display":"none"}
          }, null, 8, ["value"]),
          _createVNode(_component_a_form_item_rest, null, {
            default: _withCtx(() => [
              _createVNode(_component_UploadComponent, {
                "on-change": _ctx.onImageChange,
                "source-url": _ctx.formState.head_img
              }, null, 8, ["on-change", "source-url"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 512),
      _createVNode(_component_a_form_item, { "wrapper-col": { span: 24, offset: 6 } }, {
        default: _withCtx(() => [
          _createVNode(_component_a_button, {
            type: "primary",
            onClick: _ctx.onSubmit
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_a_button, {
            style: {"margin-left":"10px"},
            onClick: _ctx.resetForm
          }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["model", "rules", "label-col", "wrapper-col"]))
}